function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as configureApi from '@/api/configureApi.js';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      editId: '',
      brandOption: []
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(editId) {
      var _this = this;
      this.editId = editId;
      this.pram = {};
      if (!this.editId) {
        this.visible = true;
        return;
      }
      configureApi.getComDetail(editId).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _this.visible = true;
        _this.pram = res;
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _this2$pram = _this2.pram,
          extraParam = _this2$pram.extraParam,
          id = _this2$pram.id,
          postMethod = _this2$pram.postMethod,
          remark = _this2$pram.remark,
          respParam = _this2$pram.respParam,
          tempKey = _this2$pram.tempKey,
          tempName = _this2$pram.tempName;
        configureApi[_this2.editId ? 'UpdateArticle' : 'AddArticle'](_defineProperty({
          extraParam: extraParam,
          id: id,
          postMethod: postMethod,
          remark: remark,
          respParam: respParam,
          tempKey: tempKey,
          tempName: tempName
        }, "id", id || _this2.editId)).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};